import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom'

export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        style={{ color: 'white', fontSize: '10px' }}
      >
        MIS TURNOS
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Link to='/misturnos'>
          <MenuItem onClick={handleClose}
          style={{ fontSize: '10px' }}
          >HISTORIAL</MenuItem>
        </Link>
        <Link to='/turnero'>
          <MenuItem
          style={{ fontSize: '10px' }}
          onClick={handleClose}>SACAR TURNO</MenuItem>
        </Link>
      </Menu>
    </div>
  );
}